import { useState } from "react";

export default function Input({
  value,
  onChange,
  placeholder = "",
  type = "text",
  variant = "outline", // outline | filled
  disabled = false,
  fullWidth = false,
  style = {},
}) {
  const [focused, setFocused] = useState(false);

  return (
    <input
      type={type}
      value={value}
      disabled={disabled}
      placeholder={placeholder}
      onChange={(e) => onChange?.(e.target.value)}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      style={{
        ...styles.base,
        ...(variant === "outline" ? styles.outline : styles.filled),
        ...(focused ? styles.focused : {}),
        ...(disabled ? styles.disabled : {}),
        ...(fullWidth ? styles.fullWidth : {}),
        ...style,
      }}
    />
  );
}

const styles = {
  base: {
    height: 40,
    padding: "0 12px",
    fontSize: 16,
    fontWeight: 600,
    fontStyle: "italic",
    borderRadius: 2,
    outline: "none",
    transition: "all 0.15s ease",
    color: "#000",
  },

  outline: {
    border: "1px solid #ddd",
    backgroundColor: "#fff",
  },

  filled: {
    border: "1px solid transparent",
    backgroundColor: "#f5f5f5",
  },

  focused: {
    borderColor: "#3B00FF",
    boxShadow: "0 0 0 3px rgba(59, 0, 255, 0.12)",
  },

  disabled: {
    opacity: 0.6,
    cursor: "not-allowed",
  },

  fullWidth: {
    width: "100%",
  },
};
